export enum CategoryTypes {
  OBSERVATION = 'Observation',
  VIOLATION = 'Violation',
  NONE = 'None'
}
